export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=9c268972"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=9c268972
// module id = D9SO
// module chunks = 0